import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";

@Component({
  selector: 'app-privilege',
  templateUrl: './privilege.component.html',
  styleUrls: ['./privilege.component.css']
})
export class PrivilegeComponent implements OnInit {
  Admin = false;
  SalesStorage = false;
  constructor(
    public authService: AuthService
  ) { }
  email="";
  ngOnInit() {
    // setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    
    
  }
  confirm(s) {
    return confirm(s)
   }
  admin() {
    this.Admin = !this.Admin;
  }
  ss() {
    this.SalesStorage = !this.SalesStorage;
  }
}
